import { DateInput, required, TextInput } from "react-admin";

export const HouseVisitEventFormFields = () => (
  <>
    <TextInput source="name" label="Name" validate={required()} fullWidth />
    <TextInput source="hijriYear" label="Hijri year" validate={required()} fullWidth />
    <DateInput source="fromDate" label="From date" validate={required()} fullWidth />
    <DateInput source="toDate" label="To date" validate={required()} fullWidth />
  </>
);
